<template>
  <div>
    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">Pregled nepravilnosti</h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi datum</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content no-print">
      <date-picker v-model="time3" @input="dateChosen"></date-picker>
    </div>

    <!-- the concrete inconsistences -->
    <inconsistences-view
      v-if="time3"
      :date="time3"
      :tomorrow="endDate"
      :logs="logs"
    />
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

import InconsistencesView from "./InconsistencesView.vue";
import ReportService from "../../services/report.service";

export default {
  name: "Inconsistences",

  components: {
    DatePicker,
    InconsistencesView,
  },

  data() {
    return {
      isLoading: false,
      logs: [],
      time3: null,
    };
  },

  mounted() {
    this.logs = [];
  },

  methods: {
    dateChosen(date) {
      console.log(date);

      this.startDate = date;

      let nextDay1 = new Date(date);
      nextDay1.setDate(date.getDate() + 1);
      let tomorrow = nextDay1;
      // console.log(this.tomorrow);
      this.startDate.setHours(0, 0, 0, 0);
      tomorrow.setHours(0, 0, 0, 0);

      this.endDate = tomorrow;

      this.resetUi();
      this.getData();
    },

    getData() {
      this.isLoading = true;
      ReportService.GetDailyLogsByDate(this.startDate, this.endDate).then(
        (response) => {
          console.log("today");
          console.log(response.data);
          this.logs = response.data;
        }
      );
    },

    resetUi() {},
  },
};
</script>
